import { render } from "./SessionsAdd.vue?vue&type=template&id=5b913d52&scoped=true&ts=true"
import script from "./SessionsAdd.vue?vue&type=script&lang=ts"
export * from "./SessionsAdd.vue?vue&type=script&lang=ts"

import "./SessionsAdd.vue?vue&type=style&index=0&id=5b913d52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b913d52"]])

export default __exports__